import React, {Component} from 'react';
import {Helmet} from 'react-helmet';

import {t} from 'l10n';

import 'sass/headers/HeaderMemberVirtualGifts.scss';

class HeaderMemberVirtualGifts extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (
            <header className="myvirtualgifts">
                <Helmet>
                    <title>{t('My virtual gifts')}</title>
                </Helmet>
                <div className="content">
                    <h1>{t('My virtual gifts')}</h1>
                </div>
            </header>
        )
    }
}

export default HeaderMemberVirtualGifts;


// WEBPACK FOOTER //
// ./src/components/member/HeaderMemberVirtualGifts.js